// src/components/home/Layout/Layout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../../components/customComponents/Header/Header';
import Footer from '../../components/customComponents/Footer/Footer';
import styles from './Layout.module.css';
import { Toaster } from 'react-hot-toast';

export default function Layout() {
  return (
    <div className={styles.layout}>
      <Header />
      <main className={styles.content}>
        <Outlet />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}
